// extracted by mini-css-extract-plugin
module.exports = {"center":"LinkAccount_center__2jsX5","top":"LinkAccount_top__3i6L-","fixed":"LinkAccount_fixed__1dOyl"};